import React from 'react';
import { IIcon } from '../../interfaces/IIcon';
import { Icon } from '../Icon';

export function BedIcon(props: IIcon) {
    const viewBox = props.viewBox || '0 0 19 20';
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={viewBox}
            style={props.style}
            className={props.className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4785 12.528V15.5517H19V11.0162H1.52148V4.82142C1.52148 4.62599 1.44727 4.44531 1.29883 4.28675C1.15039 4.1282 0.972266 4.04707 0.760742 4.04707C0.549219 4.04707 0.371094 4.1282 0.222656 4.28675C0.0742188 4.44531 0 4.62599 0 4.82142V15.5517H1.52148V12.528H17.4785ZM3.99083 7.88194C4.36881 7.88194 4.69908 7.74435 4.98165 7.47288C5.26422 7.20142 5.40367 6.87046 5.40367 6.48744C5.40367 6.10442 5.26422 5.77346 4.98165 5.502C4.69908 5.23054 4.36881 5.09294 3.99083 5.09294C3.61284 5.09294 3.28624 5.23054 3.01835 5.502C2.75046 5.77346 2.61468 6.10442 2.61468 6.48744C2.61468 6.87046 2.75046 7.20142 3.01835 7.47288C3.28624 7.74435 3.61284 7.88194 3.99083 7.88194ZM19 8.11758V9.97368H3.31744C2.8477 9.97368 2.61468 9.78064 2.61468 9.39829C2.61468 9.01593 2.8477 8.8229 3.31744 8.8229H6.12846V6.66982C6.12846 6.47308 6.19504 6.30603 6.33189 6.16868C6.46874 6.03132 6.63519 5.9645 6.83122 5.9645H6.90519L17.8904 7.04104C18.2122 7.0893 18.4748 7.20809 18.6856 7.3937C18.8964 7.57931 19 7.8206 19 8.11758Z"
            />
        </Icon>
    );
}
